import React from 'react';
import RadioButtons, {
    RadioButtonWidthOptions,
} from '@acko-tech/building-blocks.ui.radio-button';
import {
    Wrapper,
    $primaryColorsV2,
    Container,
    Field,
    FieldContainer,
} from './styles';

interface Props {
    field: any;
    selectedValue: any;
    setValue: any;
    ctaObj?: ICtaObj;
    submitCallback?: any;
    options: {
        value: string;
        displayValue: string;
        isDisabled?: Boolean;
    }[];
    name: string;
    styles?: any;
}

interface ICtaObj {
    text: string;
    textStyles: any;
    ctaOnClick?: Function;
}
const RadioField = ({
    field,
    selectedValue,
    setValue,
    submitCallback,
    ctaObj,
    options,
    name,
    styles,
}: Props) => {
    return (
        <Wrapper>
            <Container styles={styles}>
                <FieldContainer>
                    <Field>{field}</Field>
                    {ctaObj && ctaObj.text && (
                        <div
                            onClick={() =>
                                ctaObj.ctaOnClick && ctaObj.ctaOnClick()
                            }
                        >
                            <p style={ctaObj.textStyles}>{ctaObj.text}</p>
                        </div>
                    )}
                </FieldContainer>
                <div style={{ display: 'flex', marginTop: '0.75rem' }}>
                    <RadioButtons
                        selectedValue={selectedValue}
                        options={options.filter((o) => {
                            return !o?.isDisabled;
                        })}
                        onSubmit={(value) => {
                            setValue(value, name);
                            submitCallback && submitCallback(value, name);
                        }}
                        theme={{
                            selected: $primaryColorsV2.normal,
                            selectedText: '#040222',
                            default: '#040222',
                        }}
                        fontSize={'xs'}
                        widthBwButtons={RadioButtonWidthOptions.xl}
                    />
                </div>
            </Container>
        </Wrapper>
    );
};

export default RadioField;
